import angular from 'angular'

// components
import activeToggle from './component/activeToggle.js'

export default angular
  .module('portalApp.activeToggle', [])
  .component('activeToggle', activeToggle)
  .name
